export const padding = (value: number, length: number, radix = 10): string => {
  const str = value.toString(radix);
  return str.length >= length ? str : `${'0'.repeat(length - str.length)}${str}`;
};

export const generateColors = (count: number, initColors?: string[]): string[] => {
  const colors: Set<string> = new Set(initColors);
  const randomColor = () => Math.round(Math.random() * 255);
  while(colors.size < count) {
    const color = `#${padding(randomColor(), 2, 16)}${padding(randomColor(), 2, 16)}${padding(randomColor(), 2, 16)}`;
    colors.add(color);
  }
  return Array.from(colors);
};

export function hexToRgb(hex: string): { r: number; g: number; b: number } {
  // 去除可能存在的 # 符号
  hex = hex.replace("#", "");

  // 拆分十六进制颜色值为红、绿、蓝三个部分
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return { r, g, b };
};

export const hexToHsl = (hex: string): { h: number; s: number; l: number } => {
  // 将 HEX 转换为 RGB
  const r = parseInt(hex.substring(1, 3), 16) / 255;
  const g = parseInt(hex.substring(3, 5), 16) / 255;
  const b = parseInt(hex.substring(5, 7), 16) / 255;

  // 找到最大值和最小值
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);

  // 计算亮度、饱和度和色调
  let h = 0, s = 0, l = 0;
  l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // 灰色
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }

  // 将 HSL 转换为字符串
  h = Math.round(h * 360);
  s = Math.round(s * 100);
  l = Math.round(l * 100);

  return { h, s, l };
};

export const shuffleArray = <T>(array: T[]): T[] => {
  const shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

export const sortColors = (colors: string[]) => {
  return colors.sort((a, b) => {
    const hslA = hexToHsl(a);
    const hslB = hexToHsl(b);
    if (hslA.h !== hslB.h) return hslA.h - hslB.h;
    if (hslA.s !== hslB.s) return hslA.s - hslB.s;
    return hslA.l - hslB.l;
  });
};
